import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'now'
})
export class NowPipe implements PipeTransform {
    transform(value: any): number {
        return Date.now()
    }
}